import {
  FETCHING_STREAM, FETCHING_STREAM_SUCCEDDED, FETCHING_STREAM_FAILED, INVALIDATE_STREAM,
  FETCHING_STREAM_CHILDREN, FETCHING_STREAM_CHILDREN_SUCCEDDED, FETCHING_STREAM_CHILDREN_FAILED,
  FETCHING_STREAM_ANALYTICS_REQUEST, FETCHING_STREAM_ANALYTICS_SUCCEDDED, FETCHING_STREAM_ANALYTICS_FAILED,
  SUBSCRIBING_STREAM_REQUEST, SUBSCRIBING_STREAM_SUCCEDDED, SUBSCRIBING_STREAM_FAILED,
  UNSUBSCRIBING_STREAM_REQUEST, UNSUBSCRIBING_STREAM_SUCCEDDED, UNSUBSCRIBING_STREAM_FAILED,
  UPDATING_STREAM, UPDATING_STREAM_SUCCEDDED, UPDATING_STREAM_FAILED,
  DELETING_STREAM, DELETING_STREAM_SUCCEDDED, DELETING_STREAM_FAILED,
  CREATING_GROUP, CREATING_GROUP_SUCCEDDED, CREATING_GROUP_FAILED,
  CREATING_GROUP_SECTION, CREATING_GROUP_SECTION_SUCCEDDED, CREATING_GROUP_SECTION_FAILED,
  ADD_ASSET_TO_STREAM ,ADD_ASSET_TO_STREAM_SUCCEDDED, ADD_ASSET_TO_STREAM_FAILED,
  REMOVE_ASSET_FROM_STREAM, REMOVE_ASSET_FROM_STREAM_SUCCEDDED, REMOVE_ASSET_FROM_STREAM_FAILED,
  SORT_STREAM_CHILDREN, SORT_STREAM_CHILDREN_BY_TYPE, TOGGLE_STREAM_LIST_VIEW, FETCHING_RECENTLY_VIEWED_STREAM_REQUEST, FETCHING_RECENTLY_VIEWED_STREAM_SUCCEDDED, 
  FETCHING_RECENTLY_VIEWED_STREAM_FAILED
} from './actionTypes.jsx';

import axios from 'axios';
import buildUrl from 'build-url-ts';

const apiUrl = `${process.env.REACT_APP_API_URL}`;
const STREAMS_BASE_URL = `${apiUrl}/api/2.0/streams`;
const STREAMS_PERFORMANCE_BASE_URL = `${apiUrl}/api/2.1/streams`;
const STREAMS_BASE_URL_V2 = `${apiUrl}/api/2.2/streams`;

export function fetchStream(id){
  return function (dispatch) {
    dispatch(fetchingStream(id));

    let url = buildUrl(STREAMS_PERFORMANCE_BASE_URL, {
      path: id
    });

    return axios({
      method: 'GET',
      url: url,
    })
    .then(response =>{
      return dispatch(fetchingStreamSuccedded(response.data, id))
    })
    .catch(error => {
      console.log(error);
      return dispatch(fetchingStreamFailed(error, id))
    })
  }
}

function fetchingStream(id){
  return {
    type: FETCHING_STREAM,
    payload: id
  }
}

function fetchingStreamSuccedded(json, id){
  return {
    type: FETCHING_STREAM_SUCCEDDED,
    payload: {
      stream : json,
      id : id
    }
  }
}

function fetchingStreamFailed(error, id){
  return {
    type: FETCHING_STREAM_FAILED,
    payload: {
      error: error,
      id: id
    }
  }
}

export function shouldFetchStream(state, id) {
  let resource = state.stream[id];

  if (!resource || !resource.item) {
    return true
  } else if (resource.loading) {
    return false
  } else {
    return resource.invalidated
  }

}

/* fetch stream children */

export function fetchStreamChildren(id){
  return function (dispatch) {
    dispatch(fetchingStreamChildren(id));

    let url = buildUrl(STREAMS_PERFORMANCE_BASE_URL, {
      path: `${id}/children`
    });

    return axios({
      method: 'GET',
      url: url,
    })
    .then(response =>{
      return dispatch(fetchingStreamChildrenSuccedded(id, "DESC", response.data))
    })
    .catch(error => {
      console.log(error);
      return dispatch(fetchingStreamChildrenFailed(id, error))
    })
  }
}

export function fetchOptimizedStreamChildren(id, page, limit, sort) {
  return function (dispatch) {
    dispatch(fetchingStreamChildren(id));

    let url = buildUrl(STREAMS_BASE_URL_V2, {
      path: `${id}/children`
    });

    if(!sort) {
      sort = {
        order: 'ASC',
        type: 'name'
      }
    }

    let params = {
      page,
      limit,
      sort: sort.order,
      type: sort.type
    };
    
    return axios({
      method: 'GET',
      url: url,
      params: params
    })
    .then(response =>{
      return dispatch(fetchingStreamChildrenSuccedded(id, sort, response.data))
    })
    .catch(error => {
      console.log(error);
      return dispatch(fetchingStreamChildrenFailed(id, error))
    })
  }
}


function fetchingStreamChildren(id){
  return {
    type: FETCHING_STREAM_CHILDREN,
    payload: id
  }
}

function fetchingStreamChildrenSuccedded(id, sort, json){
  return {
    type: FETCHING_STREAM_CHILDREN_SUCCEDDED,
    payload: {
      children : json,
      id : id,
      sort: sort
    }
  }
}

function fetchingStreamChildrenFailed(id, error){
  return {
    type: FETCHING_STREAM_CHILDREN_FAILED,
    payload: {
      error: error,
      id: id
    }
  }
}

/* fetch stream analytics */

export function fetchStreamAnalytics(id){
  return function (dispatch) {
    dispatch(fetchingStreamAnalytics(id));

    let url = buildUrl(STREAMS_BASE_URL, {
      path: `${id}/analytics`
    });

    return axios({
      method: 'GET',
      url: url,
    })
    .then(response =>{
      return dispatch(fetchingStreamAnalyticsSuccedded(id, response.data))
    })
    .catch(error => {
      console.log(error);
      return dispatch(fetchingStreamAnalyticsFailed(id, error))
    })
  }
}

function fetchingStreamAnalytics(id){
  return {
    type: FETCHING_STREAM_ANALYTICS_REQUEST,
    payload: id
  }
}

function fetchingStreamAnalyticsSuccedded(id, json){
  return {
    type: FETCHING_STREAM_ANALYTICS_SUCCEDDED,
    payload: {
      analytics : json,
      id : id
    }
  }
}

function fetchingStreamAnalyticsFailed(id, error){
  return {
    type: FETCHING_STREAM_ANALYTICS_FAILED,
    payload: {
      error: error,
      id: id
    }
  }
}



/*
* Subscribe stream
*/
export function subscribeStream(stream){
  return function (dispatch) {
    dispatch(subscribingStream(stream.id));

    let url = buildUrl(STREAMS_BASE_URL, {
      path: stream.id + '/follow'
    });

    return axios({
      method: 'POST',
      url: url
    })
    .then(response =>
      dispatch(subscribingStreamSuccedded(stream, stream.id))
    )
    .catch(error =>
      dispatch(subscribingStreamFailed(error, stream.id))
    )
  }
}

function subscribingStream(streamId){
  return {
    type: SUBSCRIBING_STREAM_REQUEST,
    payload: streamId
  }
}

function subscribingStreamSuccedded(stream, id){
  return {
    type: SUBSCRIBING_STREAM_SUCCEDDED,
    payload: {
      stream: stream,
      id: id
    }
  }
}

function subscribingStreamFailed(error, id){
  return {
    type: SUBSCRIBING_STREAM_FAILED,
    payload: {
      error: error,
      id: id
    }
  }
}

/*
* Unsubscribe stream
*/
export function unsubscribeStream(stream){
  return function (dispatch) {
    dispatch(unsubscribingStream(stream.id));

    let url = buildUrl(STREAMS_BASE_URL, {
      path: stream.id + '/unfollow'
    });

    return axios({
      method: 'DELETE',
      url: url
    })
    .then(response =>
      dispatch(unsubscribingStreamSuccedded(stream, stream.id))
    )
    .catch(error =>
      dispatch(unsubscribingStreamFailed(error, stream.id))
    )
  }
}

function unsubscribingStream(streamId){
  return {
    type: UNSUBSCRIBING_STREAM_REQUEST,
    payload: streamId
  }
}

function unsubscribingStreamSuccedded(stream, id){
  return {
    type: UNSUBSCRIBING_STREAM_SUCCEDDED,
    payload: {
      stream: stream,
      id: id
    }
  }
}

function unsubscribingStreamFailed(error, id){
  return {
    type: UNSUBSCRIBING_STREAM_FAILED,
    payload: {
      error: error,
      id: id
    }
  }
}

/*
* Update stream
*/
export function updateStream(stream){
  return function (dispatch) {
    dispatch(updatingStream(stream.id));

    let url = buildUrl(STREAMS_BASE_URL, {
      path: stream.id
    });

    return axios({
      method: 'PUT',
      url: url,
      data: stream
    })
    .then(response =>
      dispatch(updatingStreamSuccedded(response.data, stream.id))
    )
    .catch(error =>
      dispatch(updatingStreamFailed(error, stream.id))
    )
  }
}

function updatingStream(streamId){
  return {
    type: UPDATING_STREAM,
    payload: streamId
  }
}

function updatingStreamSuccedded(stream, id){
  return {
    type: UPDATING_STREAM_SUCCEDDED,
    payload: {
      stream: stream,
      id: id
    }
  }
}

function updatingStreamFailed(error, id){
  return {
    type: UPDATING_STREAM_FAILED,
    payload: {
      error: error,
      id: id
    }
  }
}


/*
* Delete stream
*/
export function deleteStream(id){
  return function (dispatch) {
    dispatch(deletingStream(id));

    let url = buildUrl(STREAMS_BASE_URL, {
      path: id
    });

    return axios({
      method: 'DELETE',
      url: url
    })
    .then((response) => {
      return dispatch(deletingStreamSuccedded(response.data))
    })
    .catch(error =>
      dispatch(deletingStreamFailed(error, id))
    )
  }
}

function deletingStream(id){
  return {
    type: DELETING_STREAM,
    payload: id
  }
}

function deletingStreamSuccedded(data){
  return {
    type: DELETING_STREAM_SUCCEDDED,
    payload: data
  }
}

function deletingStreamFailed(error, id){
  console.log(error);
  return {
    type: DELETING_STREAM_FAILED,
    payload: {
      error: error,
      id: id
    }
  }
}


export function createGroup(group, streamId, upsert=false){
  return function (dispatch) {
    dispatch(creatingGroup(streamId));

    let param = {
      name : group.name,
      upsert: upsert
    }

    return axios({
      method: 'POST',
      url: `${STREAMS_BASE_URL}/${streamId}/groups`,
      params: param
    })
    .then(response =>{
      return dispatch(creatingGroupSuccedded(response.data, streamId))
    })
    .catch(error => {
      return dispatch(creatingGroupFailed(error, streamId))
    })
  }
}

function creatingGroup(streamId){
  return {
    type: CREATING_GROUP,
    payload: streamId
  }
}

function creatingGroupSuccedded(json, id){
  return {
    type: CREATING_GROUP_SUCCEDDED,
    payload: {
      group: json,
      streamId: id
    }
  }
}

function creatingGroupFailed(error, id){
  return {
    type: CREATING_GROUP_FAILED,
    payload: {
      error: error,
      streamId: id
    }
  }
}


export function createSection(section, streamId) {
  return function (dispatch) {
    dispatch(creatingSection(streamId));

    let param = {
      name: section.name
    }

    return axios({
      method: 'POST',
      url: `${STREAMS_BASE_URL}/${streamId}/sections`,
      params: param
    })
      .then(response => {
        return dispatch(creatingSectionSuccedded(response.data, streamId))
      })
      .catch(error => {
        return dispatch(creatingSectionFailed(error, streamId))
      })
  }
}

function creatingSection(streamId) {
  return {
    type: CREATING_GROUP_SECTION,
    payload: streamId
  }
}

function creatingSectionSuccedded(json, id) {
  return {
    type: CREATING_GROUP_SECTION_SUCCEDDED,
    payload: {
      group: json,
      streamId: id
    }
  }
}

function creatingSectionFailed(error, id) {
  return {
    type: CREATING_GROUP_SECTION_FAILED,
    payload: {
      error: error,
      streamId: id
    }
  }
}

export function addAssetToStream(asset, streamId){
  return function (dispatch) {
    dispatch(addingAssetToStream(streamId));

    return axios({
      method: 'POST',
      url: `${STREAMS_BASE_URL}/${streamId}/assets`,
      data: asset
    })
    .then(response =>{
      return dispatch(addingAssetToStreamSuccedded(response.data,streamId))
    })
    .catch(error => {
      return dispatch(addingAssetToStreamFailed(error,streamId))
    })
  }
}

function addingAssetToStream(streamId){
  return {
    type: ADD_ASSET_TO_STREAM,
    payload: streamId
  }
} 

function addingAssetToStreamSuccedded(asset,streamId){
  return {
    type: ADD_ASSET_TO_STREAM_SUCCEDDED,
    payload: {
      asset: asset,
      streamId: streamId
    }
  }
} 

function addingAssetToStreamFailed(error,streamId){
  return {
    type: ADD_ASSET_TO_STREAM_FAILED,
    payload: {
      error: error,
      streamId: streamId
    }
  }
} 

export function removeAssetFromStream(asset, streamId){
  return function (dispatch) {
    dispatch(removingAssetFromStream(streamId));

    return axios({
      method: 'DELETE',
      url: `${STREAMS_BASE_URL}/${streamId}/assets`,
      data: asset
    })
    .then(response =>{
      return dispatch(removingAssetFromStreamSuccedded(response.data,streamId))
    })
    .catch(error => {
      return dispatch(removingAssetFromStreamFailed(error,streamId))
    })
  }
}

function removingAssetFromStream(streamId){
  return {
    type: REMOVE_ASSET_FROM_STREAM,
    payload: streamId
  }
} 

function removingAssetFromStreamSuccedded(asset,streamId){
  return {
    type: REMOVE_ASSET_FROM_STREAM_SUCCEDDED,
    payload: {
      asset: asset,
      streamId: streamId
    }
  }
} 

function removingAssetFromStreamFailed(error,streamId){
  return {
    type: REMOVE_ASSET_FROM_STREAM_FAILED,
    payload: {
      error: error,
      streamId: streamId
    }
  }
} 

/*
* Sort stream children
*/

export function sortStreamChildren(streamId, sort) {
  return function (dispatch) {
    dispatch(fetchingStreamChildren(streamId));

    let url = buildUrl(STREAMS_BASE_URL_V2, {
      path: `${streamId}/children`
    });

    let params = {
      page: 0,
      limit: 25,
      sort: sort.order,
      type: sort.type
    };

    return axios({
      method: 'GET',
      url: url,
      params: params
    })
    .then(response =>{
      return dispatch(fetchingStreamChildrenSuccedded(streamId, sort, response.data))
    })
    .catch(error => {
      console.log(error);
      return dispatch(fetchingStreamChildrenFailed(streamId, error))
    })
  }
}

export function sortStreamChildrenByType(streamId, sort) {
  console.log(streamId, sort)
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch(sortingStreamChildren(streamId, sort));
      resolve();
    });
  }
}


function sortingStreamChildren(streamId, sort) {
  return {
    type: SORT_STREAM_CHILDREN_BY_TYPE,
    payload: {
      streamId: streamId, 
      sort: sort
    }
  }
}

export function toggleListView(list) {
  return {
    type: TOGGLE_STREAM_LIST_VIEW,
    payload: {
      list: list
    }
  }
}

/*
* Common functions
*/
function fetchingAction(type){
  return {
    type: type,
    payload: {}
  }
}

function fetchingSucceededAction(type, json){
  return {
    type: type,
    payload: json
  }
}

function fetchingFailedAction(type, error){
  return {
    type: type,
    payload: error
  }
}

/*
* Stream ViewCount
*/
export function recordStreamViewedEvent(id, request) {
  return function (dispatch) {
    dispatch(recordingStreamViewedEvent(id));

    let url = buildUrl(STREAMS_BASE_URL, {
      path: `${id}/events`
    });

    return axios({
      method: 'POST',
      url: url,
      data: request
    })
      .then(response =>
        dispatch(recordingStreamViewedEventSuccedded(id, response.data))
      )
      .catch(error =>
        dispatch(recordingStreamViewedEventFailed(id, error))
      )
  }
}

function recordingStreamViewedEvent(id) {
  return {
    type: FETCHING_RECENTLY_VIEWED_STREAM_REQUEST,
    payload: id
  }
}

function recordingStreamViewedEventSuccedded(id) {
  return {
    type: FETCHING_RECENTLY_VIEWED_STREAM_SUCCEDDED,
    payload: {
      id: id
    }
  }
}

function recordingStreamViewedEventFailed(error, id) {
  return {
    type: FETCHING_RECENTLY_VIEWED_STREAM_FAILED,
    payload: {
      error: error,
      id: id
    }
  }
}